import { get, post, patch, deleteRequest } from 'helpers/api';

const rootPath = '/master_logos';

export function fetchDefaults() {
  return get(`${rootPath}/defaults.json`);
}

export function verifyLogo(id, name, companyId) {
  return post(`${rootPath}/${id}/verify`, {
    masterLogo: { name },
    companyId
  });
}

export function deleteLogo(id, companyId) {
  return deleteRequest(`${rootPath}/${id}.json`, {
    params: { companyId }
  });
}

export function revertLogo(id, companyId) {
  return patch(`${rootPath}/${id}/revert.json`, {
    companyId
  });
}

export function fetchReplaceModalData(id, oldId, companyId) {
  return get(`${rootPath}/${id}/replace/${oldId}`, {
    params: { companyId }
  });
}

export function replaceLogo(id, oldId, companyId) {
  return patch(`${rootPath}/${id}/replace/${oldId}`, {
    companyId
  });
}
